import { render, staticRenderFns } from "./upload-dishes.vue?vue&type=template&id=54aa40d7&scoped=true"
import script from "./upload-dishes.vue?vue&type=script&lang=js"
export * from "./upload-dishes.vue?vue&type=script&lang=js"
import style0 from "./upload-dishes.vue?vue&type=style&index=0&id=54aa40d7&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa40d7",
  null
  
)

export default component.exports